import type { TipoDoAlvo } from "../../base-dados.linhas";

export const EFEITOS_TITULO_INATIVAR = "O que acontece ao inativar";

export const ESCOPO_LABEL = "O que inativar";

/** Modal de subgrupo ou grupo do 103 (Figma 15577:304075). */
export const SUBGRUPO_TEXTOS = {
  titulo: "Inativar subgrupo ou grupo",
  subtitulo: "Essa ação tira o item escolhido das listas de obras novas do Hub.",
  confirmar: "Inativar",
  efeitos: [
    "Deixa de aparecer para obras novas no Nova Obra e no Adicionar Escopo macro.",
    "As obras e os escopos macro que já usam continuam com ele.",
    "Nada é excluído: dá para reativar em Mostrar inativos.",
  ],
  intro: (tipo: TipoDoAlvo) => `Você vai inativar no ${tipo.codigo} · ${tipo.nome}:`,
  registro: (grupo: string, subgrupo: string) => `${grupo} · ${subgrupo}`,
  soSubgrupo: (subgrupo: string, grupo: string) => `Só o subgrupo ${subgrupo} do ${grupo}`,
  grupoInteiro: (grupo: string, irmaos: readonly string[]) =>
    `O grupo ${grupo} inteiro (${irmaos.join(" e ")})`,
};

/** Modal de grupo do 101 e do 102 (Figma 15579:1515872). */
export const GRUPO_TEXTOS = {
  titulo: "Inativar grupo",
  subtitulo: "Essa ação tira o grupo das listas de obras novas do Hub.",
  confirmar: "Inativar grupo",
  intro: (tipos: readonly TipoDoAlvo[]) =>
    `Você vai inativar este grupo do ${tipos.map((tipo) => `${tipo.codigo} · ${tipo.nome}`).join(" e do ")}:`,
  efeitos: (tipos: readonly TipoDoAlvo[]) => [
    `Deixa de aparecer para obras novas no Nova Obra e no Adicionar Escopo macro, no ${tipos.map((tipo) => tipo.codigo).join(" e no ")}.`,
    "Obras e escopos macro que já usam continuam com ele. Dá para reativar em Mostrar inativos.",
  ],
};

/** Modal de Tipo de Obra (Figma 15579:1516323). Ativar não abre modal (Figma de 01/11, 4.6e): sai direto da linha. */
export const TIPO_TEXTOS = {
  titulo: "Inativar tipo de obra",
  subtitulo: "Essa ação tira o tipo de obra das listas de obras novas do Hub.",
  confirmar: "Inativar Tipo de Obra",
  intro: "Você vai inativar:",
  efeitos: (codigo: string) => [
    `O ${codigo} deixa de aparecer para obras novas no Nova Obra e no Adicionar da Plan. Controle.`,
    `As obras que já usam o ${codigo} continuam com ele.`,
    "Nada muda no Proteus. Dá para ativar de novo pelo mesmo botão.",
  ],
};

export const SITUACAO_INATIVO = "INATIVO";
